import React from 'react';

const ExamTimer = ({ 
  timeLeft, 
  timerType, 
  questionTimeLeft, 
  sectionTimeLeft, 
  currentSection, 
  exam,
  formatTime 
}) => {
  return (
    <div className="flex items-center gap-2">
      {/* Main Timer */}
      <div className={`px-3 py-1 rounded font-bold text-sm ${
        timeLeft < 300 ? 'bg-red-600 text-white animate-pulse' : 'bg-white text-indigo-700'
      }`}>
        <div className="flex items-center gap-1.5">
          <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{formatTime(timeLeft)}</span>
        </div>
      </div>

      {/* Question Timer (if per-question timer enabled) */}
      {timerType === 'question' && (
        <div className={`px-3 py-1 rounded font-bold text-sm ${
          questionTimeLeft < 10 ? 'bg-red-500 text-white animate-pulse' : 'bg-yellow-500 text-white'
        }`}>
          <div className="flex items-center gap-1.5">
            <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
            </svg>
            <span className="text-xs">Q:</span>
            <span>{formatTime(questionTimeLeft)}</span>
          </div>
        </div>
      )}

      {/* Section Timer (if section-wise timer enabled) */}
      {timerType === 'section' && exam?.sections && (
        <div className={`px-3 py-1 rounded font-bold text-sm ${
          sectionTimeLeft < 60 ? 'bg-red-500 text-white animate-pulse' : 'bg-purple-500 text-white'
        }`}>
          <div className="flex items-center gap-1.5">
            <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
            </svg>
            <span className="text-xs">S{currentSection + 1}:</span>
            <span>{formatTime(sectionTimeLeft)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamTimer;
